import { ETaskSource } from '@/axios/company';
import useListPageSearchParams from '@/hooks/useListPageSearchParams';
import CompanyDetail from '../Company/components/Detail';
import MonitorTable from '../Company/components/MonitorTable';

const TaskListPage = () => {
  const { detailId: companyId, listParams, updateListParams, buildDetailUrl, clearDetailParam } = useListPageSearchParams({
    path: '/tasks',
    createParams: ({ pageIndex, pageSize, search }) => ({
      pageIndex,
      pageSize,
      taskId: '',
      source: ETaskSource.Company,
      search,
    }),
  });

  return (
    <>
      {companyId && (
        <div>
          <CompanyDetail
            onReturn={() => {
              clearDetailParam();
            }}
          />
        </div>
      )}
      <div
        style={{
          display: companyId ? 'none' : 'block',
        }}
      >
        <MonitorTable
          from="all"
          externalParams={listParams}
          onParamsChange={updateListParams}
          buildCompanyDetailUrl={buildDetailUrl}
        />
      </div>
    </>
  );
};
export default TaskListPage;
